import { ChainID, Timeframe } from '@ankr.com/chains-list';

import { StatsTimeframe } from 'modules/stats/types';

export const EXCEPTION_CHAIN_MAINNET_IDS_LIST = [
  ChainID.BERACHAIN,
  ChainID.SECRET,
  ChainID.SEI,
  ChainID.ZETACHAIN,
  ChainID.TAIKO,
  ChainID.KAVA,
  ChainID.STELLAR,
  ChainID.AVAIL,
  ChainID.ALLORA,
  ChainID.BTC,
  ChainID.ZERO_G,
  ChainID.TON,
  ChainID.FUEL,
  ChainID.CORN,
  ChainID.BOTANIX,
  ChainID.TAC,
  ChainID.ATLETA,
  ChainID.NERVOS,
  ChainID.TRON,
  ChainID.NUBIT,
  ChainID.SOMNIA,
  ChainID.MOVEMENT_MAINNET,
  ChainID.MONAD,
  ChainID.MIDNIGHT,
  ChainID.NEURA,
  ChainID.ZKVERIFY,
];

export const ALLORA_TESTNET_TENDERMINT_NAME = 'Allora Testnet Tendermint';
export const ZERO_G_TESTNET_TENDERMINT_NAME = '0G Galileo Testnet Tendermint';
export const SECRET_TENDERMINT_NAME = 'Secret Network Tendermint';
export const SEI_TENDERMINT_NAME = 'Sei Tendermint';
export const SEI_TESTNET_TENDERMINT_NAME = 'Sei Testnet Tendermint';
export const KAVA_TENDERMINT_NAME = 'Kava Tendermint';
export const KAVA_TESTNET_TENDERMINT_NAME = 'Kava Testnet Tendermint';
export const TAC_TENDERMINT_NAME = 'TAC Tendermint';
export const TAC_SPB_TENDERMINT_NAME = 'TAC SPB Tendermint';
export const TAC_TURIN_TENDERMINT_NAME = 'TAC Turin Tendermint';
export const TON_NAME = 'TON';

export const TAC_EVM_PATH = 'tac' as ChainID;
export const TAC_TENDERMINT_JSON_RPC_PATH = 'tac_tendermint' as ChainID;
export const TAC_TENDERMINT_REST_PATH = 'tac_tendermint' as ChainID;
export const TAC_COSMOS_REST_PATH = 'tac_cosmos' as ChainID;
export const TAC_COSMOS_GRPC_PATH = 'tac_grpc-web' as ChainID;

export const TAC_TESTNET_SPB_EVM_PATH = 'tac_spb' as ChainID;
export const TAC_TESTNET_SPB_COSMOS_GRPC_PATH = 'tac_spb_grpc-web' as ChainID;
export const TAC_TESTNET_SPB_COSMOS_REST_PATH = 'tac_spb_cosmos' as ChainID;
export const TAC_TESTNET_SPB_TENDERMINT_REST_PATH =
  'tac_spb_tendermint' as ChainID;
export const TAC_TESTNET_SPB_TENDERMINT_RPC_PATH =
  'tac_spb_tendermint' as ChainID;
export const TAC_TESTNET_TURIN_EVM_PATH = 'tac_turin' as ChainID;
export const TAC_TESTNET_TURIN_COSMOS_GRPC_PATH =
  'tac_turin_grpc-web' as ChainID;
export const TAC_TESTNET_TURIN_COSMOS_REST_PATH = 'tac_turin_cosmos' as ChainID;
export const TAC_TESTNET_TURIN_TENDERMINT_REST_PATH =
  'tac_turin_tendermint' as ChainID;
export const TAC_TESTNET_TURIN_TENDERMINT_RPC_PATH =
  'tac_turin_tendermint' as ChainID;

export type ChainIDLinkMap = Partial<Record<ChainID, ChainID>>;

// for statistics we use paths. this mapper is used to map chain ids that are different from paths
export const CHAIN_ID_TO_PATH_MAP: ChainIDLinkMap = {
  [ChainID.ALLORA_TESTNET_REST]: ChainID.ALLORA_TESTNET,
  [ChainID.ALLORA_TESTNET_RPC]: ChainID.ALLORA_TESTNET,
  [ChainID.ALLORA_TESTNET_COSMOS_REST]: 'allora_cosmos_testnet' as ChainID,

  [ChainID.ZERO_G_GALILEO_BEACONKIT_REST]:
    '0g_galileo_testnet_beaconkit' as ChainID,
  [ChainID.ZERO_G_GALILEO_EVM]: '0g_galileo_testnet_evm' as ChainID,
  [ChainID.ZERO_G_GALILEO_TENDERMINT_REST]:
    '0g_galileo_testnet_tendermint' as ChainID,
  [ChainID.ZERO_G_GALILEO_TENDERMINT_RPC]:
    '0g_galileo_testnet_tendermint' as ChainID,

  [ChainID.SECRET_REST]: ChainID.SECRET,
  [ChainID.SECRET_RPC]: ChainID.SECRET,
  [ChainID.SECRET_COSMOS_GRPC_WEB]: ChainID.SECRET_COSMOS,
  [ChainID.SECRET_COSMOS_REST]: ChainID.SECRET_COSMOS,

  [ChainID.ZETACHAIN_COSMOS_REST_ATHENS_TESTNET]:
    'zetachain_athens_testnet' as ChainID,
  [ChainID.ZETACHAIN_EVM_ATHENS_TESTNET]:
    'zetachain_evm_athens_testnet' as ChainID,
  [ChainID.ZETACHAIN_TENDERMINT_REST_ATHENS_TESTNET]:
    'zetachain_tendermint_athens_testnet' as ChainID,
  [ChainID.ZETACHAIN_TENDERMINT_RPC_ATHENS_TESTNET]:
    'zetachain_tendermint_athens_testnet' as ChainID,
  [ChainID.ZETACHAIN_ATHENS_TESTNET]: 'zetachain_athens_testnet' as ChainID,

  [ChainID.TENET_EVM]: 'tenet_evm' as ChainID,

  [ChainID.HORIZEN_EVM]: 'horizen_eon' as ChainID,
  [ChainID.HORIZEN_TESTNET_EVM]: 'horizen_gobi_testnet' as ChainID,

  [ChainID.BERACHAIN_GUARDED_TESTNET_EVM]: 'berachain_testnet' as ChainID,

  [ChainID.SEI_COSMOS_GRPC_WEB]: 'sei_grpc' as ChainID,
  [ChainID.SEI_COSMOS_REST]: 'sei_cosmos' as ChainID,
  [ChainID.SEI_REST]: ChainID.SEI,
  [ChainID.SEI_RPC]: ChainID.SEI,
  [ChainID.SEI_EVM]: 'sei_evm' as ChainID,
  [ChainID.SEI_TESTNET]: 'sei_testnet' as ChainID,
  [ChainID.SEI_RPC_TESTNET]: 'sei_testnet' as ChainID,
  [ChainID.SEI_REST_TESTNET]: 'sei_testnet' as ChainID,
  [ChainID.SEI_COSMOS_REST_TESTNET]: 'sei_cosmos_testnet' as ChainID,
  [ChainID.SEI_COSMOS_GRPC_TESTNET]: 'sei_grpc_testnet' as ChainID,

  [ChainID.KAVA]: 'kava_evm' as ChainID,
  [ChainID.KAVA_COSMOS_REST]: 'kava_api' as ChainID,
  [ChainID.KAVA_EVM]: 'kava_evm' as ChainID,
  [ChainID.KAVA_TENDERMINT_REST]: 'kava_rpc' as ChainID,
  [ChainID.KAVA_TENDERMINT_RPC]: 'kava_rpc' as ChainID,
  [ChainID.KAVA_COSMOS_REST_TESTNET]: 'kava_testnet_api' as ChainID,
  [ChainID.KAVA_EVM_TESTNET]: 'kava_testnet_evm' as ChainID,
  [ChainID.KAVA_TENDERMINT_REST_TESTNET]: 'kava_testnet_rpc' as ChainID,
  [ChainID.KAVA_TENDERMINT_RPC_TESTNET]: 'kava_testnet_rpc' as ChainID,

  [ChainID.STELLAR]: 'stellar_horizon' as ChainID,
  [ChainID.STELLAR_HORIZON]: 'stellar_horizon' as ChainID,
  [ChainID.STELLAR_SOROBAN]: 'stellar_soroban' as ChainID,
  [ChainID.STELLAR_TESTNET_HORIZON]: 'stellar_testnet_horizon' as ChainID,
  [ChainID.STELLAR_TESTNET_SOROBAN]: 'stellar_testnet_soroban' as ChainID,

  [ChainID.TAC_EVM]: TAC_EVM_PATH,
  [ChainID.TAC_TENDERMINT_JSON_RPC]: TAC_TENDERMINT_JSON_RPC_PATH,
  [ChainID.TAC_TENDERMINT_REST]: TAC_TENDERMINT_REST_PATH,
  [ChainID.TAC_COSMOS_REST]: TAC_COSMOS_REST_PATH,
  [ChainID.TAC_COSMOS_GRPC]: TAC_COSMOS_GRPC_PATH,
  [ChainID.TAC_TESTNET_TURIN]: TAC_TESTNET_TURIN_EVM_PATH,
  [ChainID.TAC_TESTNET_TURIN_COSMOS_GRPC]: TAC_TESTNET_TURIN_COSMOS_GRPC_PATH,
  [ChainID.TAC_TESTNET_TURIN_COSMOS_REST]: TAC_TESTNET_TURIN_COSMOS_REST_PATH,
  [ChainID.TAC_TESTNET_TURIN_EVM]: TAC_TESTNET_TURIN_EVM_PATH,
  [ChainID.TAC_TESTNET_TURIN_TENDERMINT_REST]:
    TAC_TESTNET_TURIN_TENDERMINT_REST_PATH,
  [ChainID.TAC_TESTNET_TURIN_TENDERMINT_RPC]:
    TAC_TESTNET_TURIN_TENDERMINT_RPC_PATH,
  [ChainID.TAC_TESTNET_SPB]: TAC_TESTNET_SPB_EVM_PATH,
  [ChainID.TAC_TESTNET_SPB_COSMOS_GRPC]: TAC_TESTNET_SPB_COSMOS_GRPC_PATH,
  [ChainID.TAC_TESTNET_SPB_COSMOS_REST]: TAC_TESTNET_SPB_COSMOS_REST_PATH,
  [ChainID.TAC_TESTNET_SPB_EVM]: TAC_TESTNET_SPB_EVM_PATH,
  [ChainID.TAC_TESTNET_SPB_TENDERMINT_REST]:
    TAC_TESTNET_SPB_TENDERMINT_REST_PATH,
  [ChainID.TAC_TESTNET_SPB_TENDERMINT_RPC]: TAC_TESTNET_SPB_TENDERMINT_RPC_PATH,

  [ChainID.TON]: 'ton_api_v2' as ChainID,
  [ChainID.TON_REST]: 'ton_api_v2' as ChainID,
  [ChainID.TON_RPC]: 'ton_api_v2' as ChainID,

  [ChainID.FLARE_COSTON_EVM]: ChainID.FLARE_COSTON,

  [ChainID.FLARE_COSTON2_EVM]: ChainID.FLARE_COSTON2,

  [ChainID.FLARE_SONGBIRD_EVM]: ChainID.FLARE_SONGBIRD,

  [ChainID.BTC_MAINNET]: ChainID.BTC,

  [ChainID.NERVOS_EVM]: ChainID.NERVOS,

  [ChainID.TRON_REST]: ChainID.TRON,

  [ChainID.FUEL_REST]: 'fuel' as ChainID,
  [ChainID.FUEL_SEPOLIA]: 'fuel_sepolia' as ChainID,

  [ChainID.STORY]: 'story_mainnet' as ChainID,
  [ChainID.STORY_ODYSSEY]: 'story_odyssey' as ChainID,
  [ChainID.STORY_AENEID]: 'story_aeneid_testnet' as ChainID,

  [ChainID.CORN_MAIZENET]: 'corn_maizenet' as ChainID,
  [ChainID.CORN_TESTNET]: 'corn_testnet' as ChainID,

  [ChainID.GOAT]: 'goat_mainnet' as ChainID,
  [ChainID.GOAT_TESTNET]: 'goat_testnet' as ChainID,

  [ChainID.SWELL_SEPOLIA]: 'swell_sepolia' as ChainID,

  [ChainID.BOTANIX]: 'botanix_mainnet' as ChainID,
  [ChainID.BOTANIX_TESTNET]: 'botanix_testnet' as ChainID,

  [ChainID.SONIC]: 'sonic_mainnet' as ChainID,
  [ChainID.SONIC_BLAZE_TESTNET]: 'sonic_blaze_testnet' as ChainID,

  [ChainID.MATCHAIN]: 'matchain_mainnet' as ChainID,

  [ChainID.IOTA]: 'iota_mainnet' as ChainID,
  [ChainID.IOTA_EVM_TESTNET]: 'iota_evm_testnet' as ChainID,
  [ChainID.IOTA_TESTNET]: 'iota_testnet' as ChainID,

  [ChainID.SOMNIA_TESTNET]: 'somnia_testnet' as ChainID,

  [ChainID.MOVEMENT_BARDOCK_REST]: 'movement_bardock' as ChainID,
  [ChainID.MOVEMENT_MAINNET_REST]: 'movement_mainnet' as ChainID,

  [ChainID.NEURA_TESTNET]: 'neura_testnet' as ChainID,

  [ChainID.MULTICHAIN]: 'aapi_v2' as ChainID,

  [ChainID.XRP]: 'xrp_mainnet' as ChainID,

  [ChainID.ETHERLINK]: 'etherlink_mainnet' as ChainID,
  [ChainID.ETHERLINK_TESTNET]: 'etherlink_testnet' as ChainID,

  [ChainID.MONAD_TESTNET]: 'monad_testnet' as ChainID,

  [ChainID.MIDNIGHT_TESTNET]: 'midnight_testnet' as ChainID,

  [ChainID.ZKVERIFY_VOLTA_TESTNET]: 'zkverify_volta_testnet' as ChainID,

  [ChainID.XPHERE]: 'xphere_mainnet' as ChainID,
  [ChainID.XPHERE_TESTNET]: 'xphere_testnet' as ChainID,
};

type Map = Record<Timeframe, StatsTimeframe>;
export const chainsTimeframeToStatsTimeframeMap: Map = {
  [Timeframe.Hour]: StatsTimeframe.Hour,
  [Timeframe.Day]: StatsTimeframe.Day,
  [Timeframe.Week]: StatsTimeframe.Week,
  [Timeframe.Month]: StatsTimeframe.Month,
};

export const PRODUCTS_PAGE_PATHNAME = '/web3-api/chains-list/:chainID/';
